import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW0908Component } from './kymw0908.component';

/**
 * クーポン商品プロモーション設定画面の値を管理するクラス
 *
 * @export KYMW0908Model
 * @class KYMW0908Model
 */
export class KYMW0908Model {
  kymw0908Component: KYMW0908Component;

  // 編集有無フラグ
  public isEdited = false;

  // モード
  public mode: number = null;

  // 遷移元から受け取る会員タブの選択されたアイテムコード
  public coopInfoItemCoopCode = [];

  // クーポン商品連番
  public couponGoodsNo = '';

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードリスト
  public itemCodeList = [];

  // クーポン種別
  public couponType = '01';

  // 注文コード割当
  public couponOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public couponOrderNumQuotaCodeList = [];

  // 通知有無区分リスト
  public notificationFlgList: Array<any> = [
    {
      CodeValue: '0',
      CodeValueName: '0:通知無し',
      CodeName: '通知無'
    },
    {
      CodeValue: '1',
      CodeValueName: '1:通知有り',
      CodeName: '通知有'
    },
  ];
  // 通知有無区分
  public notificationFlg = '0';

  // 職員用クーポンフラグ
  public staffCouponFlg: boolean = <boolean>false;

  // クーポン名
  public couponName = '';

  // クーポン名（ｶﾅ）
  public couponNameKana = '';

  // クーポン規格名
  public couponGuideName = '';

  // クーポン規格名（ｶﾅ）
  public couponGuideNameKana = '';

  // グループ
  public groupType = 'A';

  // クーポン注文コード
  public couponOrderNum = '';

  // 通知方法お届け明細フラグ
  public deliveryFlg = false;

  // 通知方法メルマガフラグ
  public newsletterFlg = false;

  // 値引情報区分
  public couponDiscountType = '1';

  // 値引単価（一括設定）
  public couponDiscountUnitPrice = '';

  // 値引率（一括設定）
  public couponDiscountRate = '';

  // 制限数（一括設定）
  public couponLimitNum = '';

  // 会員生協別値引情報一覧
  public couponApplicablePriceList = [];

  // タイトル（EC）
  public couponTitleEc = '';

  // タイトル（お届け明細）
  public couponTitleDelivery = '';

  // 内容1（商品名・規格）
  public contentOne = '';

  // 内容2（値引き前本体価格・税込み価格）
  public contentTwo = '';

  // 内容3（値引き内容）
  public contentThree = '';

  // 内容4（値引き後本体価格・税込み価格）
  public contentFour = '';

  // 有効期限
  public validatedDate = '';

  public static readonly DISCOUNT_PRICE_FORMAT = '本体　{0}円（税込　{1}円）';
  public static readonly DISCOUNT_UNIT_PRICE_SUFFIX = '円引きクーポン';
  public static readonly DISCOUNT_RATE_SUFFIX = '％引きクーポン';

  // タイトル(お届け明細)の表示フォーマット
  public static readonly COUPON_TITLE_DELIVERY_FORMAT = 'クーポン（{0}点まで）';

  // 全選択
  public checkAll = false;

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';

  // 消費区分
  public consumeTaxDiv = '';

  // 消費税率（値引き前本体価格・税込み価格の値設定に使用）
  public consumeTaxDivRate = '';

  // アイテムコードに紐づく会員生協
  public itemRelatedCoop = [];

  // 設定済みのデータのアイテムコードとグループの組み合わせリスト
  public settedItemGroup = [];


  /**
   * 値引き前本体価格・税込み価格、値引き後本体価格・税込み価格の表示用フォーマット処理（現行デリシステムの表記）
   * 例：本体　１００円（税込　１１０円）
   */
  public formatUnitRatePrice(unitPrice: number, taxRate: number): string {
    let result = '';
    if (unitPrice) {
      // 消費税区分が「0:外税」以外の場合、税込み価格には本体価格と同値を表示する
      if (this.consumeTaxDiv !== '0') {
        result = KYMW0908Model.DISCOUNT_PRICE_FORMAT.replace('{0}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(unitPrice)));
        result = result.replace('{1}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(unitPrice)));
      } else {
        result = KYMW0908Model.DISCOUNT_PRICE_FORMAT.replace('{0}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(unitPrice)));
        result = result.replace('{1}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(Math.floor(unitPrice + (unitPrice * taxRate)))));
      }
    }
    return result;
  }

  /**
   * タイトル(お届け明細)のフォーマット処理
   */
  public formatCouponTitleDelivery(limitNum: number): string {
    let result = '';
    result = KYMW0908Model.COUPON_TITLE_DELIVERY_FORMAT.replace('{0}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(limitNum)));
    return result;
  }
}
